export const GEIST_FONT = 'Geist';
